// src/constants.ts
var ADDON_ID = "storybook/measure-addon";
var TOOL_ID = `${ADDON_ID}/tool`;
var PARAM_KEY = "measureEnabled";

export { ADDON_ID, PARAM_KEY, TOOL_ID };
